import { useEffect, useMemo } from "react";

export default function useTaskLayout(id: string) {
    const clsName = useMemo(() => {
        switch (true) {
            case ['t-101', 't-102', 't-103', 't-104', 't-105', 't-106'].includes(id):
                return 'green';
            case ['t-201', 't-202', 't-203', 't-204', 't-205', 't-206'].includes(id):
                return 'pink';
            case ['t-401', 't-402', 't-403', 't-404', 't-405', 't-406'].includes(id):
                return 'red';
            case ['t-301', 't-302', 't-303', 't-304', 't-305', 't-306'].includes(id):
                return 'blue';
        }
        return '';
    }, [id]);

    useEffect(() => {
        window.document.body.classList.add(clsName);

        return () => {
            window.document.body.classList.remove(clsName);
        }
    }, [clsName]);
}
